import { Fragment, useState } from "react";
import { menuRoutes } from "../../../router/menu";
import { usePrivilege } from "../../../components/priviledge/PriviledgeProvider";
import { FiltersProvider } from "../../../components/providers/FiltersProvider";
import PageHeader from "../../../layout/shared/page-header";
import { Button } from "rizzui";
import cn from "../../../utils/classNames";
import DocumentsList from "./DocumentsList";


const DocumentsListWrapper = () => {

    // STATES

    const [isOpen, setIsOpen] = useState(false);

    const breadCrumb = [
        { name: 'Administración' },
        { name: 'Gestión de documentos' },
        { name: 'Documentos', href: menuRoutes.documents.path },
    ];
    
    // HOOKS

    const { userCan } = usePrivilege();

    // RENDER

    return (
        <Fragment>
            <FiltersProvider>
                <PageHeader title="Listado de documentos" breadcrumb={breadCrumb}>
                {
                        userCan('create', 'document') &&
                        (
                            <div className="flex flex-col md:flex-row gap-2">
                                <Button
                                    color="primary"
                                    onClick={() => {  setIsOpen(true); }}
                                    className={cn(['mt-4 md:mt-0'])}
                                >
                                    Subir documentos
                                </Button>
                            </div>
                        )
                    }
                </PageHeader>
                <DocumentsList isOpen={isOpen} setIsOpen={setIsOpen}/>
            </FiltersProvider>
        </Fragment>

    )


}

export default DocumentsListWrapper;
